// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { Link } from "react-router-dom";
import { ABOUT_ROUTE } from "../../../../core/constants/route";
import {
    COMPANY_ADDRESS_LINE_1,
    COMPANY_ADDRESS_LINE_2,
    COMPANY_BUSINESS_ID,
    COMPANY_EMAIL,
    COMPANY_NAME,
    COMPANY_PHONE_NUMBER_DISPLAY,
    COMPANY_PHONE_NUMBER_FULL,
    COMPANY_VAT_ID,
    PRIVACY_HANDLER_EMAIL,
    PRIVACY_HANDLER_NAME,
    PRIVACY_HANDLER_PHONE_DISPLAY,
    PRIVACY_HANDLER_PHONE_FULL
} from "../../../../core/constants/company";
import { TERMS_OF_DELIVERY_ARTICLE_CLASS_NAME } from "../../../../core/constants/className";

export function TermsOfDeliveryArticle () {
    return (
        <article className={TERMS_OF_DELIVERY_ARTICLE_CLASS_NAME}>

            <h1>Toimitusehdot</h1>

            <h2>Yleiset ehdot sähköisiin palveluihin</h2>

            <p>
                <Link to={ABOUT_ROUTE}>{COMPANY_NAME}</Link>
                <br />
                {COMPANY_ADDRESS_LINE_1}
                <br />
                {COMPANY_ADDRESS_LINE_2}
                <br />
                <br />
                {PRIVACY_HANDLER_NAME} |{" "}
                <a href={"mailto:" + PRIVACY_HANDLER_EMAIL}>{PRIVACY_HANDLER_EMAIL}</a> |{" "}
                <a href={"tel:" + PRIVACY_HANDLER_PHONE_FULL}>{PRIVACY_HANDLER_PHONE_DISPLAY}</a>
                <br />
                <br />
                                       Asiakaspalvelu |{" "}
                <a href={"mailto:" + COMPANY_EMAIL}>{COMPANY_EMAIL}</a> |{" "}
                <a href={"tel:" + COMPANY_PHONE_NUMBER_FULL}>{COMPANY_PHONE_NUMBER_DISPLAY}</a>
                <br />
                <br />
                                       Business ID: {COMPANY_BUSINESS_ID}
                <br />
                <br />
                                       VAT ID: {COMPANY_VAT_ID}
                <br />
            </p>

            <p>
                Palvelu voidaan tilapäisesti sulkea tai osittain rajoittaa, jos
                <ul>
                    <li>Maksua ei ole suoritettu muistutuksista huolimatta</li>
                    <li>
                        Asiakas rikkoo yleisiä palvelimen sääntöjä tai näitä sopimusehtoja
                    </li>
                </ul>
            </p>

            <p>Tilapäisesti suljetulta tai rajoitetulta ajalta ei korvata maksuja.</p>

            <p>
                Asiakas sitoutuu noudattamaan Suomen lakeja ja viranomaismääräyksiä,
                jotka koskevat tuotetta tai palvelua.
            </p>

            <p>
                Sendanorilla on oikeus muuttaa asiakkaalle myydyn palvelun tai tuotteen
                hintaa. Hintamuutoksista tiedotetaan verkkosivustollamme 60 vuorokautta
                ennen uuden hinnan voimaan tuloa. Uusille asiakkaille myytävien
                palveluiden hinta voidaan muuttaa kuitenkin välittömästi.
            </p>

            <p>
                Asiakkaan täytyy irtisanoa palvelu tai tuote
                <b> viimeistään 30 päivää</b> ennen uuden laskutuskauden alkamista.
                Voimme tapauskohtaisesti poiketa tästä määräajasta, mikäli emme ole
                ehtineet esimerkiksi uusimaan rekisteröintimaksuja.
            </p>

            <p>
                Tuotteet tai palvelut laskutetaan (seuraavana vuonna) tilatessa
                asiakkaan valitseman tai lyhyimmän laskutuskauden mukaan. Maksettuja
                suorituksia ei palauteta vaikka asiakas irtisanoisi tuotteen kesken
                kauden. Poikkeus mikäli lupaamme tyytyväisyystakuuta, jolloin voimme
                hyvittää ensimmäisen vuoden maksusta luvatun tyytyväisyystakuun
                mukaisesti mikäli asiakas ilmoittaa miksi ei ole tyytyväinen palveluun
                ja tarjoaa Sendanorille mahdollisuuden korjata asia.
            </p>

            <p>
                Laskuissa maksuehto on <b> 14 päivää netto </b>, ellei asiakkaan kanssa
                ole toisin sovittu.
            </p>

            <p>
                <b>Yhteisökaupassa</b> on lisäksi mahdollista laatia kirjallinen sopimus.
            </p>

            <h3>Nouto / Toimitus (jos ei sähköinen tuote)</h3>

            <p>
                Nouto mahdollinen ennalta sovittuna Tampereelta
                osoitteesta {COMPANY_ADDRESS_LINE_1}, {COMPANY_ADDRESS_LINE_2}.
            </p>

            <p>
                Toimitamme tai luovutamme tuotteen vasta kun myyty kohde on maksettu
                kokonaisuudessaan mahdollista toimitusmaksua myöten.
            </p>

            <p>Toimitus mahdollinen vain Suomen sisällä, ellei toisin mainittu.</p>

        </article>
    );
}
